import { useEffect, useState } from "react";

export const useLoadingFacts = ({ isLoading }: { isLoading: boolean }) => {
  // State to track the current fact index
  const [factIndex, setFactIndex] = useState(0);
  // State to control fade animation - start with fade-out
  const [fadeState, setFadeState] = useState("fade-out");

  const factsList = [
    "The first AI-enabled medical device was approved by the FDA back in 1995.",
    "There are estimated over 2 million different medical devices in the world.",
    "The first electronic medical device was invented in 1903 - the electrocardiogram (ECG).",
    "Over 500,000 different types of medical devices exist on the market today.",
    "French physician René Laennec is credited with inventing the first stethoscope in 1816.",
    "From 1980-2019, 5 years were added to the average life expectancy thanks to advancements in medical technology.",
    "Shhh. Don't wake the sleeping auditors....",
    "Checking if the SOUP list includes minestrone...",
    "The EU Medical Device Regulations are 175 pages long, don't worry we read them all.",
    "Testing if our AI has a sense of humor...",
    "CE mark stands for Certifiably Exhausting. Or, with us, Conveniently Easy 😉",
    "Your device is this close to being welcome in over 30 countries.",
  ];

  // Effect to fade in the first fact after a delay when modal opens
  useEffect(() => {
    if (isLoading) {
      // Wait 1 second before showing the first fact
      const firstFactTimer = setTimeout(() => {
        setFadeState("fade-in");
      }, 500);

      return () => clearTimeout(firstFactTimer);
    }
  }, [isLoading]);

  // Effect to rotate through facts every 7 seconds
  useEffect(() => {
    if (!isLoading) return;

    const intervalId = setInterval(() => {
      // Start fade out
      setFadeState("fade-out");

      // After fade out, change fact and wait before fade in
      setTimeout(() => {
        setFactIndex((prevIndex) => (prevIndex + 1) % factsList.length);

        // Add a 1-second delay before fading in the new fact
        setTimeout(() => {
          setFadeState("fade-in");
        }, 1000);
      }, 500); // Half a second for fade out
    }, 5000); // 7 seconds per fact

    return () => {
      clearInterval(intervalId);
      setFadeState("fade-out");
    };
  }, [isLoading]);

  return { factIndex, fadeState, factsList };
};
